import {
  CLEAR_CART_ITEMS_DONE,
  SET_CART_DONE,
} from './constants';

export default {
  [CLEAR_CART_ITEMS_DONE](state, items) {
    state.cart = items;
  },
  [SET_CART_DONE](state, cart) {
    state.cart = cart;
  },
};
